"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ProcessSelection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var ProcessSelection = function (props) {
    var caseRuns = props.caseRuns, activeId = props.activeId, onClick = props.onClick;
    var multipleRunTypes = Object.keys(caseRuns).filter(function (key) { return caseRuns[key].length > 0; }).length > 1;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "btn-group btn-group-block process-selection" }, { children: Object.keys(caseRuns).map(function (runType) {
            var display = runType === 'prediction' ? 'Final' : runType;
            if (caseRuns[runType].length > 0) {
                var runs = caseRuns[runType].sort(function (a, b) {
                    return a.process_instance_id - b.process_instance_id;
                });
                var activeIndex = runs.findIndex(function (run) { return run.process_instance_id === activeId; });
                var classes = (0, classnames_1["default"])([
                    runType,
                    {
                        'multiple-run-types': multipleRunTypes
                    }
                ]);
                return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes }, { children: [runs.length === 1 ? ((0, jsx_runtime_1.jsx)("a", __assign({ className: "qa-".concat(runType, "-button"), href: "#/new-process", "data-process-id": runs[0].process_instance_id, onClick: onClick }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ className: (0, classnames_1["default"])([
                                    "btn",
                                    "btn-sm",
                                    { active: activeIndex !== -1 }
                                ]) }, { children: display })) }))) : null, runs.length > 1 ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "dropdown" }, { children: [(0, jsx_runtime_1.jsxs)("button", __assign({ className: (0, classnames_1["default"])([
                                        "qa-".concat(runType, "-dropdown dropdown-toggle btn btn-sm"),
                                        { active: activeIndex !== -1 }
                                    ]) }, { children: [display, " ", activeIndex !== -1 ? activeIndex + 1 : null, ' ', (0, jsx_runtime_1.jsx)("i", { className: "icon icon-caret" })] })), (0, jsx_runtime_1.jsx)("ul", __assign({ className: "menu" }, { children: runs.map(function (run, idx) {
                                        return ((0, jsx_runtime_1.jsx)("li", __assign({ className: "menu-item" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ "data-testid": "".concat(runType, "-").concat(idx, "-button"), className: (0, classnames_1["default"])([
                                                    "qa-".concat(runType, "-").concat(idx, "-button dropdown-item"),
                                                    { active: run.process_instance_id === activeId }
                                                ]), href: "#/new-process", "data-process-id": run.process_instance_id, onClick: onClick }, { children: "".concat(display, " ").concat(idx + 1) })) }), "".concat(runType, "-").concat(idx)));
                                    }) }))] }), "".concat(runType, "-dropdown"))) : null] }), "".concat(runType)));
            }
            else {
                return null;
            }
        }) })));
};
exports.ProcessSelection = ProcessSelection;
ProcessSelection.displayName = 'ProcessSelection';
//# sourceMappingURL=process-selection.js.map